import axios from './axios'

export async function getMenuService(id: Number) {
    const response = await axios.get(`/api/menu`) ;
    return response.data;
}